module.exports = __webpack_public_path__ + "img/reddit-circle.cac03593.svg";